var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnj(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#624DBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5511 5.0625C12.8289 5.09456 13.1102 5.112 13.3847 5.1615C13.9286 5.26444 14.1064 5.52319 14.0141 6.048C13.977 6.26062 13.8397 6.39169 13.6215 6.42712C13.4914 6.44544 13.3602 6.45484 13.2289 6.45525C11.4441 6.45919 9.65531 6.46256 7.8705 6.46987C7.6005 6.46987 7.33331 6.49462 7.07062 6.53737C6.18525 6.67575 5.85225 7.02675 5.778 7.88063C5.74425 8.28169 5.74425 8.28169 6.16331 8.28169H13.4916C13.6069 8.28506 13.7177 8.30644 13.8139 8.36606C14.1401 8.56519 14.0586 8.87681 14.04 9.16425C14.0254 9.39488 13.8808 9.522 13.6327 9.56813C13.5285 9.58407 13.4232 9.59122 13.3177 9.5895H6.01087C5.74087 9.5895 5.74481 9.5895 5.76675 9.84488C5.78531 10.0789 5.8005 10.3095 5.85956 10.5362C5.97037 10.9581 6.24094 11.2202 6.678 11.3372C7.16287 11.4683 7.66294 11.4969 8.163 11.5003C9.90675 11.511 11.6477 11.5076 13.392 11.5076C13.6142 11.5076 13.8212 11.5357 13.9511 11.7309C14.2031 12.1067 14.0068 12.6309 13.5658 12.7659C13.1884 12.8829 12.7918 12.9111 12.3992 12.915C10.7623 12.9431 9.12544 12.9471 7.48856 12.915C6.98376 12.902 6.48097 12.8463 5.98556 12.7485C4.81894 12.5179 4.23731 11.9509 4.041 10.8304C3.99656 10.5716 3.97069 10.3095 3.9375 10.0502V8.00494C3.96 7.80244 3.978 7.60106 4.00444 7.4025C4.15969 6.13294 4.75256 5.50913 6.05587 5.23294C6.51881 5.13338 6.99244 5.112 7.45931 5.06587C9.15188 5.0625 10.8506 5.0625 12.5511 5.0625Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32558"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnj);
export default __webpack_public_path__ + "static/media/enj.d941aef0637431a41632727f51fe5c4a.svg";
export { ForwardRef as ReactComponent };